<template>
  <div class="new">
    <Title></Title>
    <div class="new_box">
      <div class="inner">
          <div class="new_list">
            <div class="newdetail_content" v-html="mch_info"></div>
          </div>

      </div>
    </div>
  </div>

</template>

<script>
import {getMchInfoApi} from "../../api/http";
import Title from "../../components/title.vue";

export default {
  name: "introduce",
  components: {Title},
  data() {
    return {
      mch_info: ''
    }
  },
  async created() {
    let res = await getMchInfoApi()
    if (res.data.code === 200) {
      this.mch_info = res.data.data.mch_info
    } else {
      this.$message(res.data.msg)
    }
  }
}
</script>

<style lang="less" scoped>
.new_box {
  width: 100%;

  .inner {
    min-height: 500px;
    width: 1300px;
    padding: 0 100px;
    box-sizing: border-box;
    margin: 0 auto;

    .new_tab {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: flex-start;
      margin-bottom: 5px;

      .newtab_item {
        padding: 0 30px;
        font-weight: 400;
        line-height: 40px;
        font-size: 14px;
        color: #292929;
        position: relative;
      }

      .newactive:before {
        content: "";
        display: block;
        width: 50px;
        height: 2px;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -25px;
        background-color: #FF4444;
      }
    }

    .new_none {
      width: 100%;
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      box-sizing: border-box;
      background: rgba(196, 196, 196, 0.11);
      border: 0.5px solid #CCCDCE;
    }

    .new_list {
      min-height: 500px;
      width: 100%;
      padding: 15px 25px;
      box-sizing: border-box;
      background: rgba(196, 196, 196, 0.11);
      border: 0.5px solid #CCCDCE;

      .new_item {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        margin-bottom: 20px;
        background-color: #fff;

        .new_img {
          width: 265px;
          height: 198px;

          img {
            width: 265px;
            height: 198px;
          }
        }

        .new_info {
          padding: 15px;
          width: 705px;
          padding-left: 20px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          flex-direction: column;

          .newcontent {
            width: 100%;
            font-weight: 400;
            font-size: 16px;
            line-height: 22px;
            color: #292929;
          }

          .new_drop {
            display: flex;
            justify-content: space-between;
            font-weight: 400;
            font-size: 16px;
            color: #999999;

            .new_left {
              width: 50%;
              text-align: left;
            }

            .new_time {
              width: 50%;
              text-align: right;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/introduce/introduce.vue